import preview from './preview';
import setstatus from './setstatus';
import settle from './settle';

export default {
  settle,
  preview,
  setstatus,
};
